// extracted by mini-css-extract-plugin
export default {"zoomCursor":"EnlargableImage_zoomCursor__TLXrp"};